import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, TransparentButton, Stepper,
    FormWrapper } from '@checkmarx/cx-ui';
import { LdapEditMode } from '../../services/enums/ldap';
import LdapServerSettingsForm from './forms/ldapServerSettingsForm';
import LdapSchemaForm from './forms/ldapSchemaForm';
import LdapSynchronizationForm from './forms/ldapSynchronizationForm';
import LdapEditTabs from './ldapEditTabs';
import ValidationTopErrorMessage from '../portal/controls/validationTopErrorMessage';
import ToastrLevelsEnum from '../../services/enums/toastrLevelsEnum';
import ToastrService from '../../services/ui/toastrService';
import ErrorDialog from '../portal/dialogs/errorDialog';
import ConfirmationDialog from '../portal/dialogs/confirmationDialog';
import LdapSaveButton from './ldapSaveButton';
import LdapTestConnectionButtonContainer from './ldapTestConnectionButtonContainer';

@inject('translationsStore', 'rootLdapStore', 'ldapStepperStore') @observer
export default class LdapEditFormsContainer extends Component {

    SERVER_SETTINGS_STEP_ID = 1;
    DIRECTORY_SETTINGS_STEP_ID = 2;
    SYNCHRONAZATION_STEP_ID = 3;
    
    errorDialogMessage;
    ldapValidator = this.props.rootLdapStore.ldapValidator;

    state = {
        validationErrorMessage: '',
        openErrorDialog: false,
        openLeaveFormDialog: false,
        mode: this.props.mode,
        serverId: this.props.serverId,
        indexForTab: 0
    };

    constructor(props) {

        super(props);
        
        if (this.state.mode == LdapEditMode.update) {
            
            this.currentLdapStore = this.props.rootLdapStore.getStore(this.props.serverId).ldapEditStore;
            this.currentLdapValidatorStore = this.props.rootLdapStore.getValidatorStore(this.props.serverId).ldapValidator;
        }
        else {

            this.currentLdapStore = this.props.rootLdapStore.ldapStore;
            this.currentLdapValidatorStore = this.props.rootLdapStore.ldapValidator;      
        }
    }

    componentWillUnmount() {
        
        this.currentLdapValidatorStore.resetForm();
        this.currentLdapStore.resetTestConnection();
        this.currentLdapStore.resetForm();
    }

    selectedTab = (stepId) => {
        
        this.setState({
            indexForTab: stepId - 1
        });

        this.currentLdapStore.resetTestConnection();
    }

    handleNext = () => {

        this.props.ldapStepperStore.handleNext(this.steps.length);
        this.currentLdapStore.resetTestConnection();
    }
    
    handlePrev = () => {

        this.props.ldapStepperStore.handlePrev();
        this.currentLdapStore.resetTestConnection();
    }

    testConnectionButtonLabel = (stepIndex) => {

        switch (stepIndex) {
            case 0:
                return this.props.translationsStore.translate('TEST_LDAP_CONNECTION');
            case 1:
                return this.props.translationsStore.translate('TEST_LDAP_USER_SCHEMA');
            case 2:
                return this.props.translationsStore.translate('TEST_LDAP_GROUP_SCHEMA');
            default:
                return this.props.translationsStore.translate('TEST_LDAP_CONNECTION');
        }
    }

    getStepContent(stepIndex) {

        switch (stepIndex) {
            case 0:
                return <LdapServerSettingsForm 
                            currentLdapStore={this.currentLdapStore}
                            ldapValidator={this.currentLdapValidatorStore} />;
            case 1:
                return <LdapSchemaForm 
                            currentLdapStore={this.currentLdapStore}
                            ldapValidator={this.currentLdapValidatorStore} />;
            case 2:
                return <LdapSynchronizationForm 
                            currentLdapStore={this.currentLdapStore}
                            ldapValidator={this.currentLdapValidatorStore}
                            ldapServerId={this.state.serverId} />;
            default:
                return <LdapServerSettingsForm 
                            currentLdapStore={this.currentLdapStore}
                            ldapValidator={this.currentLdapValidatorStore} />;
        }
    }

    validateServerSettingsForm = () => {

        return this.currentLdapValidatorStore.validateServerSettingsForm({
            name: this.currentLdapStore.name,
            host: this.currentLdapStore.host,
            port: this.currentLdapStore.port,
            username: this.currentLdapStore.username,
            password: this.currentLdapStore.password
        });
    }

    validateLDAPSchemaForm = () => {

        return this.currentLdapValidatorStore.validateLDAPSchemaForm({
            ldapDirectoryType: this.currentLdapStore.ldapDirectoryType,
            ssoEnabled: this.currentLdapStore.ssoEnabled,
            mapLdapTo: this.currentLdapStore.mappedDomainId,
            baseDn: this.currentLdapStore.baseDn,
            additionalUserDn: this.currentLdapStore.additionalUserDn,
            userObjectClass: this.currentLdapStore.userObjectClass,
            userObjectFilter: this.currentLdapStore.userObjectFilter,
            usernameAttribute: this.currentLdapStore.usernameAttribute,
            firstNameAttribute: this.currentLdapStore.firstNameAttribute,
            lastNameAttribute: this.currentLdapStore.lastNameAttribute,
            emailAttribute: this.currentLdapStore.emailAttribute
        });
    }

    validateLDAPSynchronizationForm = () => {

        return this.currentLdapValidatorStore.validateLDAPSynchronizationForm({
            defaultRoleId: this.currentLdapStore.defaultRoleId,
            defaultTeamId: this.currentLdapStore.defaultTeamId,
            additionalGroupDn: this.currentLdapStore.additionalGroupDn,
            groupObjectClass: this.currentLdapStore.groupObjectClass,
            groupObjectFilter: this.currentLdapStore.groupObjectFilter,
            groupNameAttribute: this.currentLdapStore.groupNameAttribute,
            groupMembersAttribute: this.currentLdapStore.groupMembersAttribute,
            userMembershipAttribute: this.currentLdapStore.userMembershipAttribute
        });
    }

    isFormValid = () => {

        switch (this.props.ldapStepperStore.stepIndex) {
            case 0:
                return this.validateServerSettingsForm();
            case 1:
                return this.validateLDAPSchemaForm();
            case 2:
                return this.validateLDAPSynchronizationForm();
            default:
                return false;
        }
    }   

    initAllFormsValidationErrorMessage = () => {

        this.setState({
            validationErrorMessage: this.props.translationsStore.translate('SEE_ERRORS_BELOW')
        });
    }

    resetAllFormsValidationErrorMessage = () => {

        this.setState({
            validationErrorMessage: ''
        });
    }

    saveAndContinue = () => {
        
        this.currentLdapStore.createLDAPServer()
            .then((serverId) => {

                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.props.translationsStore.translate('LDAP_SERVER_CREATED_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({level, message});
                
                this.setState({
                    serverId: serverId,
                    mode : LdapEditMode.update,
                    selectedTabId: this.SYNCHRONAZATION_STEP_ID,
                    indexForTab: this.SYNCHRONAZATION_STEP_ID - 1,
                    ldapServerCreated: true
                });
            })
            .catch(() => {
                
                this.errorDialogMessage = this.currentLdapStore.createLDAPServerErrorMessage;
                this.openErrorDialog();
            });
    }

    resetSteps = () => {

        this.steps = this.steps.slice(0);

        this.steps.forEach((step, inx) => {

            step.selected = inx == 0 ? true : false;
        });

        this.props.ldapStepperStore.setStepIndex(0);
    }

    createServer = () => {

        this.resetAllFormsValidationErrorMessage();
        const isValid = this.isFormValid();

        if (isValid == false) {

            return;
        }

        if (this.props.ldapStepperStore.stepIndex ==this.DIRECTORY_SETTINGS_STEP_ID - 1) {

            this.saveAndContinue();
        }
        else {

            this.handleNext();
        }
    }

    updateServer = () => {

        this.resetAllFormsValidationErrorMessage();

        const form1 = this.validateServerSettingsForm();
        const form2 = this.validateLDAPSchemaForm();
        const form3 = this.validateLDAPSynchronizationForm();

        
        const validationResults = {
            form1: this.validateServerSettingsForm(),
            form2: this.validateLDAPSchemaForm(),
            form3: this.validateLDAPSynchronizationForm(),
          };

          this.setState({validationResults});

        const isValid = form1 && form2 && form3;

        if (isValid == false) {
            
            this.initAllFormsValidationErrorMessage();

            return;
        }

        this.currentLdapStore.updateLDAPServer(this.state.serverId)
            .then(() => {
                this.props.rootLdapStore.getLDAPServers();
                this.cancelAddEdit();

                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.props.translationsStore.translate('LDAP_SERVER_UPDATED_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({level, message});
            })
            .catch(() => {
                
                this.errorDialogMessage = this.currentLdapStore.updateLDAPServerErrorMessage;
                this.openErrorDialog();
            });
    }

    submit = (e) => {

        e.preventDefault();

        if (this.state.mode == LdapEditMode.update) {
            
            this.updateServer();
        }
        else if(this.state.mode == LdapEditMode.add) {

            this.createServer();
        }
    }

    performTestConnection = () => {

        const index = this.state.mode == LdapEditMode.update ? 
                            this.state.indexForTab : this.props.ldapStepperStore.stepIndex;

        this.resetAllFormsValidationErrorMessage();

        let isValid;
        
        switch (index) {
            case 0:
                isValid = this.validateServerSettingsForm();
                break;
            case 1:
                isValid = this.validateServerSettingsForm() && this.validateLDAPSchemaForm();
                break;
            case 2:
                isValid = this.validateServerSettingsForm() && this.validateLDAPSchemaForm() && this.validateLDAPSynchronizationForm();
                break;
            default:
                isValid = false;
        }

        if (isValid == false) {

            if(this.state.mode == LdapEditMode.update){
                this.initAllFormsValidationErrorMessage();
            }
                
            return;
        }

        this.currentLdapStore.testLDAPServerConnection(index);
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    openLeaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: true
        }); 
    }

    leaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false
        });

        if(this.state.ldapServerCreated){
            this.props.rootLdapStore.getLDAPServers();
        }
        
        this.cancelAddEdit();
    }

    stayFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false
        });
    }

    cancelAddEdit = () => {

        this.resetSteps();
        this.currentLdapStore.resetTestConnection();
        this.props.cancelAddEdit();
    }   

    render() {

        const { validationResults } = this.state;
        
        this.steps = [
            {
                number: this.SERVER_SETTINGS_STEP_ID,
                name: this.props.translationsStore.translate('SERVER_SETTINGS'),
                selected: true,
                complete: this.currentLdapValidatorStore.isForm1Valid
            },
            {
                number: this.DIRECTORY_SETTINGS_STEP_ID,
                name: this.props.translationsStore.translate('DIRECTORY_SETTINGS'),
                selected: false,
                complete: this.currentLdapValidatorStore.isForm2Valid
            },
            {
                number: this.SYNCHRONAZATION_STEP_ID,
                name: this.props.translationsStore.translate('SYNCHRONIZATION'),
                selected: false,
                complete: this.currentLdapValidatorStore.isForm3Valid
            }
        ];

        let stepIndex = 0;

        if (this.state.mode == LdapEditMode.add) {
            
            stepIndex = this.props.ldapStepperStore.stepIndex;
        }
        else if (this.state.mode == LdapEditMode.update) {

            stepIndex = this.state.indexForTab;
        }        

        const stepNumber = stepIndex + 1;

        const continueButtonText = this.props.translationsStore.translate('CONTINUE');
        const saveContinueButtonText = this.props.translationsStore.translate('SAVE_AND_CONTINUE');
        const backButtonText = this.props.translationsStore.translate('BACK');
        const saveButtonText = this.props.translationsStore.translate('SAVE');

        const backButton = this.state.mode == LdapEditMode.update ? null : <TransparentButton 
                                                                                disabled={stepNumber == 1}
                                                                                onClick={this.handlePrev}
                                                                                text={backButtonText}
                                                                                type='button'
                                                                            >
                                                                            </TransparentButton>;

        return(
            <FormWrapper
                style={{
                    padding: '19px 24px 24px 24px'
                }}
            >
                <div className='nav-wrapper'>
                    {
                        this.state.mode == LdapEditMode.add ? 
                            <Stepper 
                                steps={this.steps} 
                                stepNumber={stepNumber}
                                title={this.props.translationsStore.translate('ADD_NEW_LDAP_SERVER')} 
                            />
                                    :
                                        <LdapEditTabs 
                                            currentLdapStore={this.currentLdapStore}
                                            onClick={this.selectedTab} 
                                            selectedTabId={this.state.selectedTabId}
                                            validationResults={validationResults}
                                        />
                    }
                    <div style={{
                        paddingTop: this.state.validationErrorMessage != '' ? 20 : 0
                    }}>
                        <ValidationTopErrorMessage 
                            style={{
                                marginTop: 0
                            }}
                            errorMessage={this.state.validationErrorMessage}
                        />
                    </div>
                    <form onSubmit={this.submit}>
                        <div className='stepper-content'>
                            {
                                this.getStepContent(stepIndex)
                            }
                        </div>
                        <LdapTestConnectionButtonContainer 
                            currentLdapStore={this.currentLdapStore} 
                            performTestConnection={this.performTestConnection} 
                            label={this.testConnectionButtonLabel(stepIndex)}               
                        />    
                        <div className='ldap-form-buttons-wrapper'>
                            <span className='portal-blank-button' onClick={this.openLeaveFormDialogHandler}>
                                {this.props.translationsStore.translate('CANCEL')}
                            </span>
                            {backButton}
                            <LdapSaveButton 
                                currentStepNumber={stepNumber}
                                stepsLength={this.steps.length}
                                mode={this.state.mode}
                                continueButtonText={continueButtonText}
                                saveContinueButtonText={saveContinueButtonText}
                                saveButtonText={saveButtonText}
                                inProgress={this.currentLdapStore.createUpdateLDAPServersProgress}
                            >
                            </LdapSaveButton>
                        </div>
                    </form>
                </div>
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.errorDialogMessage}
                />
                <ConfirmationDialog 
                    open={this.state.openLeaveFormDialog}
                    onButtonClick={this.stayFormDialogHandler}
                    onCancelClick={this.leaveFormDialogHandler}
                    closeClick={this.stayFormDialogHandler}
                    buttonText={this.props.translationsStore.translate('STAY')}
                    cancelButtonText={this.props.translationsStore.translate('LEAVE')}
                    titleText={this.props.translationsStore.translate('CONFIRMATION')}
                    contentText={this.props.translationsStore.translate('ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_FOR_WITHOUT_SAVING')}
                />
            </FormWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ldap/ldapEditFormsContainer.jsx